import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown as ChevronDownIcon } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { tailwindVariants } from "@air/tailwind-variants";
import * as RadixCollapsible from "@radix-ui/react-collapsible";
import classNames from "classnames";
import { memo, useCallback, useState } from "react";
export const collapsibleCard = tailwindVariants({
    base: "w-full rounded p-2",
    variants: {
        variant: {
            default: "bg-surface-1 shadow-kanban dark:border dark:border-grey-5",
            ghost: "bg-transparent"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
export const CollapsibleCard = /*#__PURE__*/ memo((param)=>{
    let { testId, header, footer, children, variant = "default", onOpenChange, isDefaultExpanded = true } = param;
    const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);
    const toggleLabel = isExpanded ? "Collapse" : "Expand";
    const handleOpenChange = useCallback((isExpanded)=>{
        setIsExpanded(isExpanded);
        onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(isExpanded);
    }, [
        onOpenChange
    ]);
    return /*#__PURE__*/ _jsxs(RadixCollapsible.Root, {
        className: collapsibleCard({
            variant
        }),
        "data-testid": testId,
        onOpenChange: handleOpenChange,
        open: isExpanded,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between px-0.5 py-1",
                children: [
                    header,
                    /*#__PURE__*/ _jsx(RadixCollapsible.Trigger, {
                        children: /*#__PURE__*/ _jsx(Tooltip, {
                            label: toggleLabel,
                            children: /*#__PURE__*/ _jsx(IconButton, {
                                appearance: "ghost",
                                color: "grey",
                                label: toggleLabel,
                                size: "small",
                                children: /*#__PURE__*/ _jsx(ChevronDownIcon, {
                                    className: classNames("block h-4 w-4 transition-transform", isExpanded ? "rotate-0" : "-rotate-90")
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(RadixCollapsible.Content, {
                className: "overflow-hidden radix-state-closed:animate-radix-collapsible-slide-up radix-state-open:animate-radix-collapsible-slide-down",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: children
                    }),
                    footer
                ]
            })
        ]
    });
});
CollapsibleCard.displayName = "FilterCard";
